@if (selectedCount > 0 || reserveSpaceWhenEmpty) {
  <div
    class="selectionActionsBar flexRowContainer"
    [ngClass]="{'hidden': selectedCount === 0}">
    <span class="selectionCount body-medium">{{ selectedCount }} {{ selectionLabelKey | translate }}</span>
    <ng-content></ng-content>
  </div>
}
